var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 122,
    viewBox: "0 0 140 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76332 43.3105H135.351V47.544H4.76332V43.3105Z",
    fill: "#255056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.735107 41.0252V121.297H139.546V41.0252H135.314V117.065H51.2938V63.888H21.2083V117.065H4.96713V41.0252H0.735107ZM25.4751 117.065V68.1215H47.0603V117.065H25.4751Z",
    fill: "#255056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.778 63.888V100.563H76.05V63.888H117.778ZM80.282 96.3311V68.1215H113.544V96.3311H80.282Z",
    fill: "#255056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.735107 41.0252L70.0601 1.00029L72.1769 4.66659L2.85168 44.6915L0.735107 41.0252Z",
    fill: "#255056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.43 44.6862L68.0388 4.62333L70.1555 0.957031L139.546 41.0199L137.43 44.6862Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/residential.247f8f49a9100e83c8acb44fe97bf996.svg";
export { ForwardRef as ReactComponent };